import { League } from "../../../contracts";
import { alphabeticalSorting } from "../../sorters";
import { SortingConfiguration, CMSConfig } from "../../../Typings";
/* istanbul ignore next */
export const sortLeagues = (leagues: League[], config: CMSConfig, sportId: string): League[] => {
    if (config.sortingLogic === SortingConfiguration.Alphabetically
        && (config.sportsExcludedFromAlphabeticalSorting.indexOf(sportId) === -1)) {
        return leagues.sort(alphabeticalSorting);
    } else {
        return leagues;
    }
}